$(function() {
    const $slider = $('.js-slider');
	
    $slider.each(function() {
		const $slide = $(this);

		$slide.slick({
	        slidesToShow: 4,
	        variableWidth: true,
	        prevArrow: `<button type="button" class="slider__prev slider__arrow"><svg><use xlink:href="./img/sprites/sprite.svg#arrow-lf"></use></svg></button>`,
	        nextArrow: `<button type="button" class="slider__next slider__arrow"><svg><use xlink:href="./img/sprites/sprite.svg#arrow-rg"></use></svg></button>`,
	        dots: true,
			slidesToScroll : 4,
	        responsive: [
				{
	                breakpoint: 1280,
	                settings: {
	                    slidesToScroll: 3,
	                }
	            },
				{
	                breakpoint: 1000,
	                settings: {
	                    slidesToScroll: 2,
	                }
	            },
	            {
	                breakpoint: 576,
	                settings: {
	                    arrows: false,
						slidesToScroll: 1,
	                }
	            }
	        ]
	    })

	});
})